import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';
import { Navigate } from 'react-router-dom';
import AuthGuard from '../layout/Auth/AuthGuard';
const WebContent = Loadable(lazy(() => import('../sections/web-content/WebContent')))

// ==============================|| COMPONENT ROUTING ||============================== //

const WebRoutes = {
  path: '/',
  element: <AuthGuard allowedRoles={['SUPER_ADMIN']}/>,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'web',
          children: [
            {
              // This makes /menu automatically open /menu/categories
              index: true, 
              element: <Navigate to="/web/pages" replace /> 
            },
            {
              path: '/web/pages',
              element: <WebContent />
            }
          ]
        }
      ]
    }
  ]
};

export default WebRoutes;
